<template>
    <div class="backdrop backdrop-search">
        <div class="shop-modal modal-search">
            <div class="modal-inner modal-search-top-selector">
                <div class="search-form-wrapper">
                    <form
                        class="form-group search-input-group"
                        :action="'/' + __('frontend_js.routes.search-result')"
                        id="main-searchbar"
                    >
                        <div class="input-group">
                            <input
                                type="text"
                                name="q"
                                class="form-control search-input"
                                id="mainPageSearch"
                                :placeholder="__('frontend_js.layout.search-placeholder')"
                                aria-describedby="inputGroupPrepend"
                                required
                                autocomplete="off"
                                @input="searchTimeOut"
                                v-model="searchTerm"
                            />
                        </div>
                    </form>
                    <div v-if="loading" class="spinnerWrapper">
                        <span v-if="gant == true">
                            <spinner-gant data-spinner />
                        </span>
                        <span v-else>
                            <spinner-vermont data-spinner />
                        </span>
                    </div>
                    <button class="small-icons search2-icon" type="submit" form="main-searchbar"></button>
                    <div class="suggest-results-wrapper row mx-0 flex-wrap-reverse flex-md-wrap">
                        <div v-if="categoriesFound || articlesFound || storesFound" class="pages col-12 col-md-4 col-lg-3">
                            <searchBarCategories :categoriesSearchResults="categories" />
                            <searchBarArticles :articlesSearchResults="articles" />
                            <searchBarStores :storeSearchResults="stores" />
                        </div>
                        <div class="coloredProducts coloredProducts--search col-12 col-md-8 col-lg-9">
                            <custom-product-quick-search-list
                                :coloredProducts="coloredProducts"
                                :vermont="vermont"
                                :gant="gant"
                                v-if="coloredProductsFound"
                            >
                            </custom-product-quick-search-list>
                            <div class="flex justify-center mb-3" v-if="coloredProductsFound && coloredProducts.length >= 8">
                                <a
                                    :href="'/' + __('frontend_js.routes.search-result') + '?q=' + searchTerm"
                                    class="text-black hover:text-black hover:no-underline"
                                >
                                    {{ __('frontend_js.search.show_more') }}
                                </a>
                            </div>
                            <div
                                v-if="searchTerm.length && !coloredProductsFound && loading == false"
                                class="container message-panel warning mx-auto"
                            >
                                {{ __('frontend_js.search.no-results') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import searchBarCategories from './_parts/search-bar-categories.vue';
import searchBarArticles from './_parts/search-bar-articles.vue';
import searchBarStores from './_parts/search-bar-stores.vue';
import customProductQuickSearchList from '../custom-colored-product/lists/custom-product-quick-search-list.vue';
export default {
    components: {
        searchBarCategories,
        searchBarArticles,
        searchBarStores,
        customProductQuickSearchList,
    },
    props: {
        gant: { type: Boolean },
        vermont: { type: Boolean },
        authCheck: { type: Boolean },
        url: { type: String, default: '/quick-search' },
    },
    data() {
        return {
            searchTerm: '',
            coloredProducts: [],
            categories: [],
            articles: [],
            stores: [],
            loading: false,
            timer: null,
        };
    },
    computed: {
        searchResultData() {
            return (this.stores.length > 0) |
                (this.articles.length > 0) |
                (this.categories.length > 0) |
                (this.coloredProducts && this.coloredProducts.length > 0)
                ? true
                : false;
        },
        coloredProductsFound() {
            return this.coloredProducts.length > 0;
        },
        categoriesFound() {
            return this.categories.length > 0;
        },
        articlesFound() {
            return this.articles.length > 0;
        },
        storesFound() {
            return this.stores.length > 0;
        },
    },
    methods: {
        searchTimeOut() {
            this.loading = true;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.fetchSearchResult();
            }, 500);
        },
        fetchSearchResult() {
            if (this.searchTerm.length) {
                this.loading = true;
                this.$http
                    .get(this.url + '/' + this.searchTerm)
                    .then(res => {
                        if (res.data.colored_products) {
                            this.coloredProducts = res.data.colored_products;
                        }
                        if (res.data.categories) {
                            this.categories = res.data.categories;
                        }
                        if (res.data.articles) {
                            this.articles = res.data.articles;
                        }
                        if (res.data.stores) {
                            this.stores = res.data.stores;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" >
.backdrop {
    overflow-y: hidden;
}

.modal-search {
    height: 100vh;
    overflow-y: scroll;
}

.search-form-wrapper .input-group {
    border-right: none;
}

.suggest-results-wrapper {
    position: absolute;
    top: 82px;
    display: flex;
}

.pages {
    background-color: #f8f8f8;
    min-height: 100%;
    width: 25%;
    padding: 25px;
}

.pages > * {
    height: fit-content;
}

.pages h3 {
    font-size: 12px;
    text-transform: uppercase;
}

.pages ul {
    font-size: 14px;
}

.spinnerWrapper {
    position: relative;
    right: 50px;
}

:deep(.spinner),
:deep(.ajax-loader-vermont) {
    font-size: 32px;
    margin-left: 0;

    &::before {
        font-size: 0.45em;
    }
}
</style>
